<template>
  <Page>
    <v-form v-if="hasMultipleClients" @submit.prevent="">
      <v-row dense>
        <v-col>
          <v-select
            :items="clients"
            item-value="id"
            item-text="title_with_id"
            v-model="options.params.client_id"
            label="Client"
            :disabled="!user.is_copy_to"
          />
        </v-col>
      </v-row>
    </v-form>

    <v-data-table v-bind="customAttrs" :options.sync="options">
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="editCsv(item)" v-bind="attrs" v-on="on">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit CSV Download</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="openDeleteModal(item.id)" v-bind="attrs" v-on="on">
              mdi-delete
            </v-icon>
          </template>
          <span>Delete CSV Download</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-btn color="primary" @click="addCsv">Add Custom CSV Download</v-btn>

    <v-dialog v-model="showDeleteDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          Delete Custom CSV Download
        </v-card-title>

        <v-card-text>
          Are you sure you want to delete this custom CSV download?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDeleteModal">No</v-btn>
          <v-btn color="red" text @click="confirmDelete">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import { mapActions, mapGetters, mapState } from "vuex";
import dataTablePagination from "@/mixins/dataTablePagination";

export default {
  name: "BrowseCsvDownloads",
  components: { Page },
  mixins: [dataTablePagination],
  data() {
    return {
      loading: true,
      showDeleteDialog: false,
      deleteTargetId: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Download Name", value: "name" },
        { text: "Download Description", value: "description" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      options: {
        params: {
          client_id: ""
        }
      }
    };
  },
  computed: {
    ...mapState("csvs", { csvs: "items" }),
    ...mapGetters("clients", ["hasMultipleClients", "selectedClient"]),
    ...mapState("clients", { clients: "items" }),
    ...mapState("auth", ["user"]),
    customAttrs() {
      return {
        ...this.defaultAttrs,
        noDataText: "You have no custom CSV downloads.",
        noResultsText: "No matching custom CSV downloads"
      };
    }
  },
  watch: {
    selectedClient(newVal) {
      this.options.params.client_id = newVal ? newVal.id : null;
    }
  },
  methods: {
    ...mapActions("csvs", ["getPaginated", "deleteCsv"]),
    addCsv() {
      this.$router.push("/reports/custom-csvs/add");
    },
    editCsv(item) {
      this.$router.push(`/reports/custom-csvs/edit/${item.id}`);
    },

    openDeleteModal(id) {
      this.deleteTargetId = id;
      this.showDeleteDialog = true;
    },

    closeDeleteModal() {
      this.showDeleteDialog = false;
      this.deleteTargetId = null;
    },

    confirmDelete() {
      if (!this.deleteTargetId) return;

      this.loading = true;
      this.deleteCsv(this.deleteTargetId)
        .then(() => this.getPaginatedProxy())
        .finally(() => {
          this.loading = false;
          this.closeDeleteModal();
        });
    }
  },
  created() {
    if (this.selectedClient) {
      this.options.params.client_id = this.selectedClient.id;
    }
  }
};
</script>

<style>
td.v-data-table__mobile-row {
  max-width: 88vw;
}
.v-data-table__mobile-row__cell {
  max-width: 75vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
